import { SVGProps } from 'react';

const KeySquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M14.33 6.22L17.78 9.68M9.02 10.37L1.17 18.22C0.74 18.66 0.49 19.24 0.49 19.85V22.35C0.49 22.67 0.62 22.96 0.83 23.18C1.05 23.39 1.34 23.51 1.65 23.51H5.11C5.41 23.51 5.70 23.39 5.92 23.18C6.14 22.96 6.26 22.67 6.26 22.35V21.20C6.26 20.90 6.38 20.61 6.59 20.39C6.81 20.17 7.10 20.05 7.41 20.05H8.56C8.87 20.05 9.16 19.93 9.38 19.72C9.59 19.50 9.71 19.21 9.71 18.90V17.75C9.71 17.45 9.84 17.15 10.05 16.94C10.27 16.72 10.56 16.60 10.87 16.60H11.07C11.68 16.60 12.26 16.35 12.70 15.92L13.63 14.99M12.48 1.26C13.01 0.77 13.71 0.49 14.44 0.49C15.16 0.49 15.87 0.77 16.40 1.26L22.74 7.60C23.23 8.13 23.51 8.83 23.51 9.56C23.51 10.29 23.23 10.99 22.74 11.52L18.48 15.79C17.95 16.28 17.25 16.56 16.52 16.56C15.79 16.56 15.09 16.28 14.56 15.79L8.22 9.45C7.72 8.92 7.45 8.22 7.45 7.49C7.45 6.76 7.72 6.06 8.22 5.53L12.48 1.26Z"
      stroke="currentColor"
      strokeWidth={1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default KeySquare;
